import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
  Alpine.data("countdown", (endTime) => {
    return {
      timeLeft: 0,
      intervalId: null,

      get hours() {
        return Math.floor(this.timeLeft / 3600);
      },
      get minutes() {
        return Math.floor((this.timeLeft % 3600) / 60);
      },
      get seconds() {
        return this.timeLeft % 60;
      },

      getSecondsLeft() {
        return Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      },

      init() {
        this.timeLeft = this.getSecondsLeft();

        if (this.timeLeft <= 0) {
          this.$dispatch("countdown");
          return;
        }

        this.intervalId = setInterval(() => {
          this.timeLeft = this.getSecondsLeft();

          if (this.timeLeft <= 0) {
            clearInterval(this.intervalId);
            this.$dispatch("countdown");
          }
        }, 1000);

        this.$el.addEventListener("countdown", () => {
          if (this.intervalId) clearInterval(this.intervalId);
        });
      },
    };
  });
});
